import { lazy } from "react";
import type { SolutionRoute } from "../routes";
import type { SolutionSettings } from "../settings";
import type { NavItem } from "../../nav";
import { Icon } from "../../ui";

const PartnersListPage = lazy(() => import("./list").then((m) => ({ default: m.PartnersListPage })));
const PartnerPage = lazy(() => import("./partner").then((m) => ({ default: m.PartnerPage })));
const PartnersSettings = lazy(() => import("./settings").then((m) => ({ default: m.PartnersSettings })));

/** Partners and perks: the brands that support the business, and the perks they give members. */

export const routes: SolutionRoute[] = [
  { solution: "partners", path: "partners", element: <PartnersListPage /> },
  { solution: "partners", path: "partners/:id", element: <PartnerPage /> },
];

export const settings: SolutionSettings[] = [{ solution: "partners", key: "partners", label: "Partners", icon: Icon.flag, need: "partners.view", Component: PartnersSettings }];

export const nav: NavItem = { to: "/partners", label: "Partners", icon: Icon.flag, solution: "partners", need: "partners.view" };
